import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/SQL.svg`).attr('x', 20).attr('y', 10).attr('height', 70)
      .call(this.open_Window, {target: 'Diagram', width: 850, height: 720, exeFunc: this.form_Diagram})

      this.gmx_Line(this.canvasForms, 95, this.Canvas.CanvasWidth, 50, 50, '#83D2F5', .5, 1)

      let x = 95
      this.canvasForms
      .append('text')
      .attr('id', 'PHASE')
      .attr('x', x).attr('y', 25).attr('fill', '#757575').attr('font-size', 13)
      .text(this.diagram && this.diagram.PHASE ? this.diagram.PHASE : '')

      this.canvasForms
      .append('text')
      .attr('id', 'DIAGRAM_NAME')
      .attr('x', x).attr('y', 50).attr('fill', '#000').attr('font-size', 25)
      .text(this.diagram && this.diagram.DIAGRAM_NAME ? this.diagram.DIAGRAM_NAME : this.config.diagram)

      this.canvasForms
      .append('text')
      .attr('id', 'DIAGRAM_DESC')
      .attr('x', x).attr('y', 68).attr('fill', '#44A9DF').attr('font-size', 14)
      .text(this.diagram && this.diagram.DIAGRAM_DESC ? this.diagram.DIAGRAM_DESC : '')

      if(this.stages.length > 0) this.draw_Diagram() 

    },


  }
}